WiseMetering.Views.GroupDestroy = WiseMetering.Views.Modal.Destroy.extend({

    title: () => i18next.t('modal.title.groups.destroy'),

    afterDestroy: function() {
        return WiseMetering.zones.fetch();
    }
});
